import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
/**
 * Detect if the current browser is iOS Safari.
 * Returns true for iPad, iPhone, or iPod running Safari (not Chrome or Firefox on iOS).
 */
export function detectIosSafari(): boolean {
  return (
    typeof window !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/CriOS/.test(navigator.userAgent) &&
    !/FxiOS/.test(navigator.userAgent)
  );
}
